export default __webpack_public_path__ + "static/media/ASDASD.72b736cb.png";